import ReactDOM from 'react-dom';

//components
import SpotlightCarousel from  '@/components/page/spotlight/SpotlightCarousel';



const SpotlightCarouselPortal = () => {
    const targetContainer = document.getElementById('react-spotlight-carousel-portal');

    if (targetContainer === null){
        return null;
    }
    return ReactDOM.createPortal(
        <SpotlightCarousel />, targetContainer
    );
};

export default SpotlightCarouselPortal;